import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import { SEO } from "@/components/seo/SEO";

export const SubscriptionRequired = () => {
  const navigate = useNavigate();

  return (
    <>
      <SEO 
        title="Subscription Required - Upgrade to Access Premium Content"
        description="Upgrade to our medical MCQ subscription to access practice questions, study materials, and mock exams."
      />
      
      <div className="container py-12">
        <div className="max-w-2xl mx-auto text-center">
          <Card className="border-amber-200 bg-amber-50/50">
            <CardHeader className="pb-4">
              <div className="w-16 h-16 mx-auto mb-4 bg-amber-100 rounded-full flex items-center justify-center">
                <Lock className="w-8 h-8 text-amber-600" />
              </div>
              <CardTitle className="text-2xl text-amber-800">
                Subscription Required
              </CardTitle>
            </CardHeader>
            
            <CardContent className="pt-0 space-y-6">
              <p className="text-lg text-amber-700">
                This content requires an active subscription to access. Start your free 3-day trial to unlock all premium features.
              </p>
              
              <div className="p-4 bg-white rounded-lg border border-amber-200">
                <h3 className="font-semibold text-amber-800 mb-2">What you'll get:</h3>
                <ul className="text-sm text-amber-700 space-y-1 text-left">
                  <li>• 3-day free trial to test all features</li>
                  <li>• Full access to 2000+ medical MCQs</li>
                  <li>• Detailed explanations and references</li>
                  <li>• Progress tracking and analytics</li>
                  <li>• Mock exam simulations</li>
                  <li>• Priority customer support</li>
                </ul>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button 
                  onClick={() => navigate('/pricing')}
                  className="bg-amber-600 hover:bg-amber-700"
                >
                  Start Free Trial
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
                <Button 
                  variant="outline"
                  onClick={() => navigate('/dashboard')}
                  className="border-amber-300 text-amber-700 hover:bg-amber-50"
                >
                  Back to Dashboard
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
};
